module.exports = {
          srcSet: __webpack_public_path__ + "eca28ba6437e9356337e82b33227cb05-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "eca28ba6437e9356337e82b33227cb05-66.jpg",width: 66,height: 66}],
          src: __webpack_public_path__ + "eca28ba6437e9356337e82b33227cb05-66.jpg",
          toString:function(){return __webpack_public_path__ + "eca28ba6437e9356337e82b33227cb05-66.jpg"},
          
          width: 66,
          height: 66
        }